// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root___SMOP","modal":"Modal_modal__2Ity9","close":"Modal_close__Cjpto","modalMobileFullscreen":"Modal_modalMobileFullscreen__kz7dO"};